import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlert = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4376 8.04185L3.79177 37.5002C3.42795 38.1302 3.23545 38.8446 3.23341 39.5721C3.23138 40.2996 3.41988 41.015 3.78016 41.6471C4.14044 42.2792 4.65995 42.8059 5.287 43.1749C5.91404 43.5438 6.62677 43.7422 7.35427 43.7502H42.6459C43.3734 43.7422 44.0862 43.5438 44.7132 43.1749C45.3403 42.8059 45.8598 42.2792 46.22 41.6471C46.5803 41.015 46.7688 40.2996 46.7668 39.5721C46.7648 38.8446 46.5723 38.1302 46.2084 37.5002L28.5626 8.04185C28.1912 7.42957 27.6683 6.92335 27.0443 6.57202C26.4202 6.2207 25.7162 6.03613 25.0001 6.03613C24.284 6.03613 23.58 6.2207 22.9559 6.57202C22.3319 6.92335 21.809 7.42957 21.4376 8.04185Z",
			stroke: "#FEAD06",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 18.75V27.0833",
			stroke: "#FEAD06",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 35.417H25.0208",
			stroke: "#FEAD06",
			strokeWidth: 4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgAlert);
export default ForwardRef;
